import AdLayout from "../../app-core/AdLayout";
import DropTablesNav from "./DropTablesNav";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";
import {
  Provider as TftSetProvider,
  fromNum,
} from "common/src/data/TftSet.bs.js";

type Tables = { loot: any; goldValues: any; breakpoints: any; loot5: any };

export default function IxtalTables({ tables }: { tables: Tables }) {
  return (
    <AdLayout>
      <TftSetProvider.make value={fromNum(160)}>
        <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
          <DropTablesNav route={"Ixtal"} />
          <h2 className="h2 p-4 pb-0 flex items-center gap-1">
            {T.traits("TFT16_Explorer") + " " + T.common("Rewards")}
          </h2>
          {Object.entries(tables.loot).map(([key, options]: any) => {
            return (
              <div key={key}>
                <h3 className="pt-12 px-4 pb-5 h4 leading-tight">{`${Math.max(0, tables.breakpoints[key])} Sunshards (${tables.goldValues[key]}g)`}</h3>
                <LootGrid data={options.map((v: any) => [v.odds, v.loot])} />
              </div>
            );
          })}
          <h2 className="h2 p-4 pt-32 flex items-center gap-1">
            {T.traits("TFT16_Ixtal") + " 7 Bonus " + T.common("Rewards")}
          </h2>
          <LootGrid data={tables.loot5.orb.map((v: any) => [v.odds, v.loot])} />
        </div>
      </TftSetProvider.make>
    </AdLayout>
  );
}
